import React from 'react';

const InputError = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.815 12L19.466 6.349C19.5775 6.23757 19.6659 6.10527 19.7263 5.95966C19.7867 5.81405 19.8178 5.65798 19.8178 5.50035C19.8179 5.34272 19.7869 5.18663 19.7266 5.04098C19.6663 4.89534 19.5779 4.76299 19.4665 4.6515C19.3551 4.54 19.2228 4.45155 19.0772 4.39119C18.9316 4.33082 18.7755 4.29973 18.6178 4.29968C18.4602 4.29964 18.3041 4.33064 18.1585 4.39092C18.0128 4.45119 17.8805 4.53957 17.769 4.651L12.118 10.303L6.46599 4.651C6.23835 4.43837 5.937 4.32251 5.62555 4.32787C5.3141 4.33323 5.01692 4.45938 4.79672 4.67971C4.57652 4.90003 4.45054 5.19729 4.44537 5.50875C4.4402 5.8202 4.55624 6.12148 4.76899 6.349L10.421 12L4.76899 17.651C4.60195 17.8192 4.48837 18.033 4.44254 18.2656C4.39671 18.4982 4.42067 18.7391 4.51141 18.9581C4.60215 19.1771 4.75562 19.3644 4.95252 19.4964C5.14941 19.6284 5.38094 19.6992 5.61799 19.7C5.92499 19.7 6.23199 19.583 6.46599 19.349L12.118 13.697L17.769 19.349C17.8803 19.4607 18.0125 19.5493 18.1581 19.6097C18.3037 19.6702 18.4598 19.7013 18.6175 19.7013C18.7751 19.7013 18.9313 19.6702 19.0769 19.6097C19.2225 19.5493 19.3547 19.4607 19.466 19.349C19.5776 19.2375 19.6661 19.1052 19.7265 18.9595C19.7869 18.8138 19.8179 18.6577 19.8179 18.5C19.8179 18.3423 19.7869 18.1861 19.7265 18.0405C19.6661 17.8948 19.5776 17.7624 19.466 17.651L13.815 12Z"
        fill="#FF3049"
      />
    </svg>
  );
};

export default InputError;
